<script setup lang="ts">
import type { NuxtError } from '#app';

const { error } = defineProps<{ error: NuxtError }>();

const localePath = useLocalePath();

function handleError(): void {
    void clearError({ redirect: localePath('/') });
}

const is400Error = computed(() => {
    return error.statusCode >= 400 && error.statusCode < 500;
});
</script>

<template>
    <div>
        <template v-if="is400Error">
            <NuxtLayout name="default">
                <div class="container m-auto">
                    <div class="grid justify-items-center gap-4 text-white">
                        <h1>{{ error.statusCode }}</h1>
                        <p>{{ error.statusMessage }}</p>
                        <button class="btn btn-primary-a" @click="handleError">
                            {{ $t('common.backToHome') }}
                        </button>
                    </div>
                </div>
            </NuxtLayout>
        </template>
        <template v-else>
            <div class="container m-auto grid h-screen place-items-center">
                <div class="grid justify-items-center gap-4 text-white">
                    <h1>{{ error.statusCode }}</h1>
                    <p>{{ error.statusMessage }}</p>
                    <p>{{ $t('error.errorPage500Message') }}</p>
                </div>
            </div>
        </template>
    </div>
</template>
